import { Telemetry,ValidTelemetryEvent } from '~commonInfra/services/Telemetry';

// Event name has to match what appears in the database
export enum MetricsTelemetryEvents {
  MetricConfigurationUpdated = 'MetricConfigurationUpdated',
}

export interface MetricConfigurationEditedEvent extends ValidTelemetryEvent {
  type: MetricsTelemetryEvents.MetricConfigurationUpdated;
  metric_luid: string;
  postConfiguration: string;
  preConfiguration: string;
  success: boolean;
}


export function sendMetricConfigurationEditedEvent(metric_luid: string,
  postConfiguration: string,
  preConfiguration: string,
  success: boolean) {
  Telemetry.sendEvent<MetricConfigurationEditedEvent>({
    type: MetricsTelemetryEvents.MetricConfigurationUpdated,
    metric_luid,
    postConfiguration,
    preConfiguration,
    success,
  });
}
